import React from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Table,
} from 'reactstrap';
import {parseDate} from '../../utils/Utilities';
import {DD_MM_YYYY_HH_MM_SS} from '../../utils/Global';
// import label from '../../message/Label'
import label from 'enqc-utilities/src/label/Label'
import PropTypes from "prop-types";
import BaseComponent from "../BaseComponent";


export default class ComponentItemInformationModal extends BaseComponent{

    constructor(props) {
        super(props);
        let componentGroup = this.props.componentGroup?this.props.componentGroup:{}
        let componentItems = componentGroup.componentItems?componentGroup.componentItems:[]
        this.state ={
            componentGroup:componentGroup,
            componentItems:componentItems
        }
    }

    componentWillReceiveProps(props, nextContext) {
        if(props.showing){
            let componentGroup = props.componentGroup?props.componentGroup:{}
            let componentItems = componentGroup.componentItems?componentGroup.componentItems:[]

            this.setState({
                componentGroup:componentGroup, componentItems:componentItems
            })
        }
    }


    render() {
        let {componentGroup, componentItems} = this.state

        return (
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    style={{minWidth:'90%'}}
                    size="xl"
                    centered={true}
                    isOpen={this.props.showing}
                    backdrop={true}>
                    {super.render()}
                    <ModalHeader>
                        {label.ComponentItems}
                    </ModalHeader>
                    <ModalBody>
                        {this.renderComponentItemes()}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={e=>{
                                e.preventDefault()
                                this.props.onClose()
                            }}>
                            {label.Close}
                        </Button>
                    </ModalFooter>
                </Modal>

            </>
        )
    }

    renderComponentItemes = () =>{
        return (
            <Row key={2}>
                <Col>
                    {this.renderComponentItemesTable()}
                </Col>
            </Row>
        )
    }


    renderComponentItemesTable = () =>{
        let {componentItems} = this.state
        return (
            <Card className="p-0">
                <CardBody className="p-0">
                    <Table className="p-0" responsive hover>
                        <thead className="bg-info font-weight-bolder">
                        <tr>
                            <th>#</th>
                            <th>{label.Label}</th>
                            <th>{label.Description}</th>
                            <th>{label.Created}</th>
                            <th>{label.Updated}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                           componentItems.map((item, index)=>(
                                <tr key={item.id}>
                                    <th scope="row">{(++index)}</th>
                                    <td>{item.label}</td>
                                    <td>{item.description}</td>
                                    <td>{parseDate(item.created, DD_MM_YYYY_HH_MM_SS)}</td>
                                    <td>{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        )
    }


}

ComponentItemInformationModal.propTypes = {
    componentGroup:PropTypes.object,
    showing:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
}
